module.exports = __webpack_public_path__ + "img/consumer.1c11ee9f.png";